import { get } from 'lodash-es';
import { getTotalRebates } from 'site-modules/shared/components/inventory/utils/get-total-rebates';

/**
 * Calculates the Edmunds suggested price based on VIN data and selected incentives.
 *
 * @param {Object} params - The parameters for the price calculation.
 * @param {Object} params.vinData - The vehicle information data containing prices.
 * @param {Array} params.selectedIncentives - The active list of selected incentives/rebates.
 * @param {Array} params.primaryLoanIncentives - The primary finance incentives included in edmundsSuggestedPrice.
 * @param {boolean} params.showLeasePayments - Flag indicating whether to use lease-specific pricing.
 * @returns {number} The final suggested price, or 0 if the price is not compliant.
 */
export function getEdmundsSuggestedPrice({ vinData, selectedIncentives, primaryLoanIncentives, showLeasePayments }) {
  const prices = get(vinData, 'prices');
  if (!get(prices, 'edmundsSuggestedPriceIsCompliant', false)) return 0;
  const incentives = selectedIncentives || [];
  const allSelectedIncentives = getTotalRebates({ incentives, showLeasePayments });
  const primaryFinanceIncentives = getTotalRebates({
    incentives: primaryLoanIncentives || [],
    showLeasePayments: false,
  });
  return get(prices, 'edmundsSuggestedPrice', 0) - allSelectedIncentives + primaryFinanceIncentives;
}
